import React from 'react';
import { Search } from 'lucide-react';

interface SearchBarProps {
  onQuickLinksOpen: () => void;
}

export function SearchBar({ onQuickLinksOpen }: SearchBarProps) {
  const handleClick = () => {
    onQuickLinksOpen();
  };

  const isMac = typeof navigator !== 'undefined' && navigator.platform.includes('Mac');
  const shortcutText = isMac ? '⌘ K' : 'Ctrl K';

  return (
    <div className="flex items-center w-96 max-w-md mx-4 cursor-pointer" onClick={handleClick}>
      <div className="relative w-full">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Search className="h-4 w-4 text-gray-400 dark:text-gray-500" />
        </div>
        <input
          type="text"
          className="block w-full pl-10 pr-20 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-theme-light-bg dark:bg-theme-dark-bg text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#E34290] focus:border-[#E34290] cursor-pointer"
          placeholder="Search or quick links..."
          readOnly
        />
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
          <span className="text-xs text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded border border-gray-300 dark:border-gray-600">
            {shortcutText}
          </span>
        </div>
      </div>
    </div>
  );
}
